<div class="modal-header">
    <h5 class="modal-title">Duplicate Observation</h5>
    <button type="button" class="btn btn-info cancel" (click)="activeModal.dismiss('cancel')">
        <i class="fas fa-times"></i>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit(form)" errorTailor>
        <div *ngIf="showAdditionalOptionsSPM()" class="p-1">
            <label class="form-label" for="performanceMeasureType">Performance Measure Type <span class="required">*</span></label>
            <select id="performanceMeasureType" class="form-select" formControlName="performanceMeasureType">
                <option *ngFor="let opt of filteredPerformanceMeasureTypes" [ngValue]="opt.value">{{opt.label}}</option>
            </select>
        </div>

        <div class="p-1">
            <label class="form-label" for="evalUserId">Select Evaluator <span class="required">*</span></label>
            <select id="evalUserId" class="form-select" formControlName="evalUserId">
                <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
                <option *ngFor="let opt of evaluators" [value]="opt.user.userID">{{opt.user.displayName}}</option>
            </select>
        </div>

        <div class="p-1">
            <label class="form-label" for="schoolYear">School Year <span class="required">*</span></label>
            <select id="schoolYear" class="form-select" formControlName="schoolYear">
                <option [defaultSelected]=true value="" disabled>Select One</option>
                <option *ngFor="let opt of schoolYears" [value]="opt">{{opt}}</option>
            </select>
        </div>

        <div class="text-end p-1">
            <button type="submit" class="btn btn-primary me-2" [ladda]="busy">
                <i class="far fa-plus"></i> Duplicate Observation
            </button>
            <button type="button" class="btn btn-info m-2" [ladda]="busy" (click)="activeModal.close()">Cancel</button>
        </div>
    </form>
</div>

